import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);

export namespace NewsProductCarousel {
	let setupSlider = () => {

		let productCarousels = document.querySelectorAll('.js-news-product-carousel');

		//For Each Hero Slider Loop through and setup swiper
		productCarousels.forEach((carousel, index) => {
			carousel.classList.add(`product-carousel__swiper--${index}`);
			const swiper = new Swiper(`.product-carousel__swiper--${index}`, {
				slidesPerView: 1,
				spaceBetween: 0,

				// Navigation arrows
				navigation: {
					nextEl: `.product-carousel__swiper--${index} .swiper-button-next`,
					prevEl: `.product-carousel__swiper--${index} .swiper-button-prev`,
				},

				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 0,						
					},
					500: {
						slidesPerView: 2,
						spaceBetween: 10,
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 10,
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: 10,
					}
				}
			});
		});
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', NewsProductCarousel.init);
